import React, { Fragment } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
export const OrderSummaryRowSkeleton = () => {
  return (
    <Fragment>
      {Array.from({ length: 3 }).map((_, index) => (
        <div className="selected-products" key={index}>
          <Skeleton height={80} width={80} borderRadius="8px" />
          <div className="selected-products-info web-fill-width">
            <Skeleton height={20} width="100%" />

            <Skeleton height={15} width="60%" style={{ marginTop: 16 }} />
          </div>
        </div>
      ))}
    </Fragment>
  );
};
